export const ONE_DAY_MILLISECONDS = 1000 * 60 * 60 * 24;
export const FOUR_HOURS = 1000 * 60 * 60 * 4;
export const PRIVACY_GUIDELINES_TEXT =
  "In accordance with data protection regulations, each person identified or identifiable in the files must sign a rights authorisation form. Please also ensure that the background does not contain any sensitive information (photos, religious objects, etc.). If people are filmed in work areas, please ensure that computer workstations are locked and that posters on the walls are well blurred, so that no unnecessary information is visible.";

export const NEGOTIATED_USAGE_RIGHTS_TOOLTIP = {
  ingka: `Who has the rights to use this asset?
Global: includes all Ingka markets and ROIG (Retailers outside Ingka group)
All Ingka markets: includes all Ingka markets
Specific market(s): the usage rights belong only to the market(s) chosen here`,
  external: `Please specify which markets are allowed to use this asset(s).
Only markets with usage rights can view, find and publish the asset(s).`,
} as const;
export const SIMILARITY_SEARCH_URL =
  "https://ladan.ingka.com/similarity-search";

export const INSTRUCTION_PAGE_LINKS = {
  ingka:
    "https://confluence.build.ingka.ikea.com/display/GP/Common+Questions+and+instructions+-+Ingka+DAM",
  external:
    "https://confluence.build.ingka.ikea.com/spaces/GP/pages/1246722407/Common+questions+and+instructions+ROIG",
};

export const INSTRUCTION_VIDEOS_URL =
  "https://confluence.build.ingka.ikea.com/display/ODCH/Instruction+videos%3A+Ingka+DAM";

export const SUPPORT_TICKET_SHOPPABLE_REQUEST_URL =
  "https://supportme.ingka.com/esc?id=sc_cat_item&sys_id=0de5677e879047146960c8809bbb35e8&table=sc_cat_item";
